(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86],{

/***/ 6163:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platforms",
      function () {
        return __webpack_require__(1896);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4190);
/* harmony import */ var src_state_manager_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5789);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1268);
/* harmony import */ var src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2088);
/* harmony import */ var src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1872);
/* harmony import */ var src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(662);
/* harmony import */ var src_core_components_spinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2503);
/* harmony import */ var src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5113);
//** React Imports


// ** Next Imports

//** Effect Imports

// ** Source Imports







const keyValuesKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].keyValues */ .Z.keyValues;
const keyValuesEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].keyValues */ .Z.keyValues;
const platformsKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].landing_platforms */ .Z.landing_platforms;
const platformsEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].landing_platforms */ .Z.landing_platforms;
const Platforms = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 451).then(__webpack_require__.bind(__webpack_require__, 5451)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5451)
            ]
    },
    ssr: false
});
const PlatformsPage = ()=>{
    const settings = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const { language  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_10__/* .useStore */ .oR)(src_state_manager_global__WEBPACK_IMPORTED_MODULE_3__/* ["default"].locale */ .ZP.locale);
    const { landingDetails , platforms  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_10__/* .useStore */ .oR)(src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__/* ["default"].landing */ .ZP.landing);
    const [loadingMedia, setLoadingMedia] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__/* .getLandingDetail */ .d_)({
            query: {
                $or: [
                    {
                        "data.groupName": "landing"
                    },
                    {
                        "data.groupName": "shared"
                    }
                ],
                $and: [
                    {
                        ["data.".concat(keyValuesKeys.language)]: language === "ru" ? keyValuesEnum.language.ru : keyValuesEnum.language.en
                    }
                ]
            }
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__/* .getTableForLanding */ .hg)({
            key: "platforms",
            tableName: "landing_platforms",
            query: {
                $and: [
                    {
                        ["data.".concat(platformsKeys.language)]: language === "ru" ? platformsEnum.language.ru : platformsEnum.language.en
                    }
                ]
            }
        });
    }, [
        language
    ]);
    const isLoading = landingDetails.loading || platforms.loading || loadingMedia;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_spinner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                settings: settings
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                sx: {
                    height: isLoading ? 0 : "auto",
                    visibility: isLoading ? "hidden" : "visible"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Platforms, {
                    landingDetails: landingDetails.data,
                    platforms: platforms,
                    setLoadingMedia: setLoadingMedia
                })
            })
        ]
    });
};
PlatformsPage.getLayout = (page)=>page;
PlatformsPage.acl = {
    action: "read",
    subject: "platforms-page"
};
/* harmony default export */ __webpack_exports__["default"] = (PlatformsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [524,100,515,774,888,179], function() { return __webpack_exec__(6163); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);